
    import {Component, Vue} from 'vue-property-decorator'

    @Component({
        name: 'bmgl'
    })
    export default class bmgl extends Vue {
        bmxxDataList: Array<any> = [];
        bmxxData = {
            bmmc: '',
            fbmid: '',
            orderNum: 0,
            bmcj: '',
            bmid: '',
            isSchool: 0
        };
        currentNo: number = 1;
        pageSize: number = 10;
        pageTotal: number = 0;
        showbmxxVisible: boolean = false;
        searchText: string = '';
        loading: boolean = false;
        sjbm = []
        rules = {
            bmmc: [
                {required: true, message: '部门名称不能为空', trigger: 'blur'}
            ],
            fbmid: [
                {required: true, message: '上级部门不能为空', trigger: 'blur'},
                {validator: this.validatedFbm, trigger: 'blur'},
            ],
            orderNum: [
                {required: true, message: '排序号不能为空', trigger: 'blur'}
            ]
        }
        selectBm = ''

        created() {
            this.searchData();
        }

        mounted() {
            this.querybmjb();
        }

        validatedFbm(rule, value, callback) {
            if (this.bmxxData.bmid) {
                if (this.bmxxData.bmid == value) callback(new Error('上级部门不能与本部门一致'))
                else callback()
            } else callback()
        }

        handleSizeChange(val: number) {
            this.pageSize = val;
            this.searchData();
        }

        handleCurrentChange(val: number) {
            this.currentNo = val;
            this.searchData();
        }

        changeIndex() {
            this.currentNo = 1
        }

        searchData() {
            this.loading = true;
            this.$request({
                url: '/bjba/bmxx/search',
                method: 'get',
                params: {
                    currentNo: this.currentNo,
                    pageSize: this.pageSize,
                    bmxxName: `%${this.searchText}%`
                }
            })
                .then(response => {
                    this.loading = false;
                    console.log(response);
                    let data = response.data;
                    if (data.code == 200) {
                        this.bmxxDataList = data.data.content;
                        this.pageTotal = data.data.totalElements
                    } else {
                        this.$message.error(data.message)
                    }
                })
                .catch(error => {
                    this.loading = false;
                    console.log(error)
                    this.$message.error(msg)
                });
        }

        querybmjb() {
            this.$request({
                method: 'get',
                url: '/bjba/bmxx/querybmjb',
            }).then((response: any) => {
                console.log(response)
                this.sjbm = response.data;
            }).catch(err => {
                console.log(err)
            })
        }

        getBm(user) {

            if (user.fbmid && user.fbmid != '0') {
                for (var i = 0; i < this.sjbm.length; i++) {

                    if (this.sjbm[i].bmid == user.fbmid) {
                        return this.sjbm[i].bmmc
                    }
                }
            } else return '无'

        }

        showbmxx(val: any) {
            this.showbmxxVisible = true;
            this.$nextTick(() => {
                this.bmxxData.bmid = ''
                this.$refs['form'].resetFields();
                if (val) {
                    var newBmmc = val.bmmc.substr(val.bmmc.indexOf('-')+1,val.bmmc.length)
                    this.bmxxData.bmmc = newBmmc
                    this.bmxxData.fbmid = val.fbmid
                    this.bmxxData.orderNum = val.orderNum
                    this.bmxxData.bmid = val.bmid
                    this.bmxxData.isSchool = val.isSchool
                }

            })

        }

        savebmxx(bmxx: any) {
            console.log(this.bmxxData);
            this.$refs.form.validate((valid) => {
                if (valid) {
                    for (let i = 0; i < this.sjbm.length; i++) {
                        if (this.sjbm[i].bmid == this.bmxxData.fbmid) {
                            this.selectBm = this.sjbm[i].bmmc;
                        }
                    }
                    if (this.bmxxData.fbmid == "0") {
                        this.bmxxData.bmcj = '1'
                    } else if (!this.bmxxData.fbmid || this.bmxxData.fbmid === null) {
                        this.bmxxData.bmcj = '1'
                    } else {
                        this.bmxxData.bmcj = '2'
                    }
                    if (this.bmxxData.bmcj == '2') {
                        this.bmxxData.bmmc = this.selectBm + "-" + this.bmxxData.bmmc;
                    }
                    this.$request({
                        url: '/bjba/bmxx/save',
                        method: 'post',
                        data: this.bmxxData
                    })
                        .then(response => {
                            console.log(response);
                            let data = response.data;
                            if (data.code == 200) {
                                this.$message.success(data.message)
                                this.showbmxxVisible = false;
                                this.searchData();
                                this.querybmjb();
                            } else {
                                this.$message.error(data.message)
                                this.bmxxData.bmmc = this.bmxxData.bmmc.substr(this.bmxxData.bmmc.indexOf('-')+1,this.bmxxData.bmmc.length)
                            }

                        })
                        .catch(error => {
                            console.log(error)
                            this.bmxxData.bmmc = this.bmxxData.bmmc.substr(this.bmxxData.bmmc.indexOf('-')+1,this.bmxxData.bmmc.length)
                            this.$message.error(msg)
                        });
                }
            })
        }

        deletebmxx(bmid: String) {
            this.$confirm('是否确定删除此部门信息', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$request({
                    url: '/bjba/bmxx/delete',
                    method: 'get',
                    params: {
                        bmxxId: bmid
                    }
                })
                    .then(response => {
                        let data = response.data;
                        if (data.code == 200) {
                            this.$message.success(data.message)
                        } else {
                            this.$message.error(data.message)
                        }
                        this.searchData();
                        this.querybmjb();
                    })
                    .catch(error => {
                        console.log(error)
                        this.$message.error(msg)
                    });
            }).catch(() => {
            });
        }
    }
